/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityChangeHistoryRecord
 */
export interface EntityChangeHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    fieldName: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    oldValue: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    newValue: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EntityChangeHistoryRecord
     */
    changedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    changedBy: string;
    /**
     * 
     * @type {string}
     * @memberof EntityChangeHistoryRecord
     */
    changedByRole?: string | null;
}

/**
 * Check if a given object implements the EntityChangeHistoryRecord interface.
 */
export function instanceOfEntityChangeHistoryRecord(value: object): value is EntityChangeHistoryRecord {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('fieldName' in value) || value['fieldName'] === undefined) return false;
    if (!('oldValue' in value) || value['oldValue'] === undefined) return false;
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    if (!('changedAt' in value) || value['changedAt'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    return true;
}

export function EntityChangeHistoryRecordFromJSON(json: any): EntityChangeHistoryRecord {
    return EntityChangeHistoryRecordFromJSONTyped(json, false);
}

export function EntityChangeHistoryRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityChangeHistoryRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityName': json['entityName'],
        'entityId': json['entityId'],
        'action': json['action'],
        'fieldName': json['fieldName'],
        'oldValue': json['oldValue'],
        'newValue': json['newValue'],
        'changedAt': (new Date(json['changedAt'])),
        'changedBy': json['changedBy'],
        'changedByRole': json['changedByRole'] == null ? undefined : json['changedByRole'],
    };
}

export function EntityChangeHistoryRecordToJSON(json: any): EntityChangeHistoryRecord {
    return EntityChangeHistoryRecordToJSONTyped(json, false);
}

export function EntityChangeHistoryRecordToJSONTyped(value?: EntityChangeHistoryRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityName': value['entityName'],
        'entityId': value['entityId'],
        'action': value['action'],
        'fieldName': value['fieldName'],
        'oldValue': value['oldValue'],
        'newValue': value['newValue'],
        'changedAt': value['changedAt'].toISOString(),
        'changedBy': value['changedBy'],
        'changedByRole': value['changedByRole'],
    };
}

